import { Modal } from 'react-daisyui';
import { useModalsContext } from '../../providers/ModalsProvider/Modals.context';
import AdvanceSearchModalProvider from './AdvanceSearchModal.provider';
import './AdvanceSearchModal.styles.scss';
import AdvanceFilters from './components/AdvanceFilters.component';
import InfoSection from './components/InfoSection.component';
import LeadsTable from './components/LeadsTable.component';
import SearchBarHeader from './components/SearchBarHeader.component';

export default function AdvanceSearchModal() {
  const { advanceSearchModalIsOpen, setAdvanceSearchModalIsOpen } =
    useModalsContext();

  function resetModal() {
    setAdvanceSearchModalIsOpen(false);
  }

  return (
    <AdvanceSearchModalProvider>
      <Modal.Legacy
        open={advanceSearchModalIsOpen}
        onClickBackdrop={() => {
          resetModal();
        }}
        className="AdvanceSearchModal"
      >
        <SearchBarHeader resetModal={resetModal} />

        <Modal.Body className="AdvanceSearchModal__Body">
          <div className="AdvanceSearchModal__Body__MainSection">
            <InfoSection />
            <LeadsTable />
          </div>

          <AdvanceFilters />
        </Modal.Body>
      </Modal.Legacy>
    </AdvanceSearchModalProvider>
  );
}
